import { useState, useEffect } from "react";
import api from "../../api";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import CityDeliveryRow from "./CityDeliveryRow";

export default function SupplierProvinceAccordion({ province, warehouseId }) {
  const [open, setOpen] = useState(false);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  // تغییر شماره ۱: هرگاه warehouseId تغییر کرد، اگر آکاردئون باز است،
  // دوباره اطلاعات را Fetch کن یا حداقل لیست قبلی را پاک کن تا از انبار قبلی نمایش داده نشود
  useEffect(() => {
    if (open) {
      fetchCities();
    } else {
      setCities([]); // پاک کردن لیست وقتی بسته است تا وقتی دوباره باز شد مجبور به fetch مجدد شود
    }
  }, [warehouseId]);

  const fetchCities = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/operation/supplier-delivery/${province.id}/${warehouseId}/`);
      setCities(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleAccordion = () => {
    if (!open && cities.length === 0) {
      fetchCities();
    }
    setOpen(!open);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
      <div className="flex justify-between items-center cursor-pointer" onClick={toggleAccordion}>
        <h3 className="font-semibold text-gray-700">{province.name}</h3>
        <ChevronDownIcon className={`w-5 h-5 transition-transform ${open ? "rotate-180" : ""}`} />
      </div>

      {open && (
        <div className="mt-4 space-y-2">
          {loading ? (
            <p className="text-sm text-gray-400">در حال دریافت اطلاعات انبار جدید...</p>
          ) : cities.length > 0 ? (
            cities.map(city => (
              <CityDeliveryRow
                key={`${warehouseId}-${city.id}`} // تغییر شماره ۲: استفاده از ترکیب ID انبار در Key
                city={city}
                warehouseId={warehouseId}
              />
            ))
          ) : (
            <p className="text-sm text-gray-500">شهری یافت نشد.</p>
          )}
        </div>
      )}
    </div>
  );
}
